import styled, { css } from 'styled-components';

import {
    Flex,
    Button,
    spaceMixin,
    mediaMixin,
} from '@zillow/constellation';

import ConnectedModuleCard from 'app/shared/components/ConnectedModuleCard';

export const StyledFlexPaymentCard = styled(Flex)`
    min-width: 0;

    ${mediaMixin('md', css`
        &.PaymentCard-Even {
            padding-right: ${spaceMixin('sm')};
        }
    `)}
`;

export const StyledConnectedModuleCard = styled(ConnectedModuleCard)`
    min-height: 510px;
    display: flex;
    flex-direction: column;
`;

export const StyledNoBorderButton = styled(Button)`
    border: none;
`;

export const StyledFluidFlex = styled(Flex)`
    width: 100%;

    ${mediaMixin('md', css`
        width: initial;
    `)}
`;
